import { values } from 'ramda';
import { ThunkHelper } from 'invision-core';
export var SET_REVOKE_GIFT_ORDER_MODEL = 'SET_REVOKE_GIFT_ORDER_MODEL';
export var setRevokeGiftOrderModel = function setRevokeGiftOrderModel(model) {
  return {
    type: SET_REVOKE_GIFT_ORDER_MODEL,
    payload: {
      model: model
    }
  };
};
export var REVOKE_GIFT_ORDER_CONSTANTS = {
  BEGIN: 'REVOKE_GIFT_ORDER_BEGIN',
  SUCCESS: 'REVOKE_GIFT_ORDER_SUCCESS',
  FAILURE: 'REVOKE_GIFT_ORDER_FAILURE'
};
var REVOKE_GIFT_ORDER_EVENTS = values(REVOKE_GIFT_ORDER_CONSTANTS);
var revokeGiftOrderPromise = function revokeGiftOrderPromise(dispatch, reasonCode, orderId) {
  return ThunkHelper(dispatch, REVOKE_GIFT_ORDER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RevokeGiftOrder',
    data: {
      ReasonCode: reasonCode,
      Id: orderId
    }
  });
};
export var revokeGiftOrder = function revokeGiftOrder(model, orderId) {
  return function (dispatch) {
    return revokeGiftOrderPromise(dispatch, model.reasonCode, orderId);
  };
};